import { Menu } from 'lucide-react';

import Logo from '@/assets/images/Logo.svg';
import { Breadcrumb } from '@/components/Breadcrumb';

interface HeaderProps {
  setSidebarOpen: (_open: boolean) => void;
}

export function Header({ setSidebarOpen }: HeaderProps) {
  return (
    <header className="bg-highlight h-16 flex items-center justify-between px-4 md:px-8 py-3 fixed top-0 right-0 left-0 md:left-64 z-40">
      <button
        className="md:hidden p-2 rounded hover:bg-yellow-200 mr-2"
        aria-label="Abrir menu lateral"
        onClick={() => setSidebarOpen(true)}
      >
        <Menu className="w-6 h-6 text-gray-700" />
      </button>
      <Breadcrumb />
      <div className="flex items-center gap-2 pr-2">
        <img src={Logo} alt="Culture Monitor Logo" className="w-16" />
      </div>
    </header>
  );
} 